import { render, staticRenderFns } from "./MyVideo.vue?vue&type=template&id=b6cf6e0e&scoped=true"
import script from "./MyVideo.vue?vue&type=script&lang=js"
export * from "./MyVideo.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/data-list.css?vue&type=style&index=0&id=b6cf6e0e&prod&scoped=true&lang=css&external"
import style1 from "./MyVideo.vue?vue&type=style&index=1&id=b6cf6e0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cf6e0e",
  null
  
)

export default component.exports